// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2goUx","content":"styles_content__2PHQJ","selectAll":"styles_selectAll__3Ydo5"};